import { baseBackend } from "../../../../../../api/base/baseUrl";
import { URL_BOOKING_CANCELLATIONS } from "./endpoints";

export const createBookingCancellation = async (bookingCancellation) => {
  return await baseBackend.post(
    URL_BOOKING_CANCELLATIONS,
    JSON.stringify(bookingCancellation),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
